import { createContext, useContext, useState } from 'react';
import { ContextProviderProps } from './interfaces';
import config from '../config/config';

/* Context for holding language that is set in brand configs (in app.tsx) */

interface LanguageContextType {
    language: string,
    setLanguage: (val: string) => void;
};

export const LanguageContext = createContext({} as LanguageContextType);
export const useLanguageContext = () => useContext(LanguageContext);

export const LanguageContextProvider = ({ children }: ContextProviderProps) => {
    const [language, setLanguage] = useState<string>(config.language);
    return <LanguageContext.Provider value={{ language, setLanguage }}>
        {children}
    </LanguageContext.Provider>
};